import React, { useCallback } from 'react';
import {
  DestinationPlatform,
  VideoTypeConfig,
} from 'blocks/DestinationPlatforms';
import Wizard, { Step } from 'components/Wizard';
import VideoWizardDestinationStep from '../VideoWizardDestinationStep';
import { VideoFlowAction, VideoFlowState } from './state/types';
import { VideoFlowStep } from './types';

type UseDestinationStepProps = {
  state: VideoFlowState;
  stateDispatch: React.Dispatch<VideoFlowAction>;
  wizardRef: React.RefObject<Wizard<VideoFlowStep>>;
};

export type Destination = {
  platform: DestinationPlatform | undefined;
  videoType: VideoTypeConfig | undefined;
};

export default function useDestinationStep({
  state,
  stateDispatch,
  wizardRef,
}: UseDestinationStepProps) {
  const handleDestinationChosen = useCallback(
    (platform: DestinationPlatform, videoType?: VideoTypeConfig) => {
      stateDispatch({
        type: 'destination-select',
        payload: {
          platform,
          videoType,
        },
      });
      wizardRef.current?.next();
    },
    [stateDispatch, wizardRef],
  );

  const step: Step<VideoFlowStep> = {
    completedName: 'Video Clipped',
    component: (
      <VideoWizardDestinationStep
        objective={state.objective}
        requiredAspectRatio={
          state.isAspectRatioLocked ? state.aspectRatioName : undefined
        }
        onDestinationChosen={handleDestinationChosen}
      />
    ),
    name: 'Clip Selection',
    renderCancelButton: () => null,
    renderNextButton: () => null,
    stepId: VideoFlowStep.DESTINATION,
  };

  return {
    step,
  };
}
